import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, AtualizarParametroSistema } from './types';

export const INITIAL_STATE: AtualizarParametroSistema = {
	status: 0,
	data: null,
};

export default function modules(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarParametroSistema {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_PARAMETRO_SISTEMA: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_SISTEMA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_SISTEMA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_PARAMETRO_SISTEMA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
